import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "../../commonMeta";

export interface IScreenFormMeta {
    bankID: FormInputMeta;
    corporateName: FormInputMeta;
    id: FormInputMeta;
    screenConfiguration: FormInputMeta;
    id2: FormInputMeta;
    name: FormInputMeta;
    nameCheckbox: FormInputMeta;
    text: FormInputMeta;

    schema: any;
}

const screenFormMeta = {} as IScreenFormMeta;

screenFormMeta.bankID = {...BankIDInputMeta, label: "ID Banque"};

screenFormMeta.corporateName = {...CorporateNameInputMeta, label: "Raison Sociale"};

screenFormMeta.id = {
  name: "id",
  type: "text",
  label: "ID",
  placeholder: "Veuillez entrer l'ID svp...",
  validation: yup.string().required("Champ obligatoire !")
};

screenFormMeta.screenConfiguration = {
  name: "screenConfiguration",
  type: "text",
  label: "Configuration Écran", 
  placeholder: "Veuillez entrer la configuration écran svp...",
  validation: yup.string().required("Champ obligatoire !")
};

screenFormMeta.id2 = {
  name: "id2",
  type: "text",
  label: "ID", 
  placeholder: "Veuillez entrer l'ID svp...",
  validation: yup.string().required("Champ obligatoire !")
};

screenFormMeta.name = {
  name: "name",
  type: "text",
  label: "Nom", 
  placeholder: "Veuillez entrer le nom svp...",
  validation: yup.string().required("Champ obligatoire !")
};

screenFormMeta.nameCheckbox = {
  name: "nameCheckbox",
  type: "checkbox",
  label: "", 
  placeholder: "",
//   validation: yup.string().required("Champ obligatoire !")
};

screenFormMeta.text = {
    name: "text",
    type: "textarea",
    label: "Texte", 
    placeholder: "Veuillez entrer le Text svp...",
    validation: yup.string().required("Champ obligatoire !")
  };
  

screenFormMeta.schema = yup.object().shape(getValidationSchema(screenFormMeta));

export default screenFormMeta;